/**
 * Design tokens for the Omega AI HPC Console (neo-brutalist theme).
 *
 * JS mirror of the Tailwind @theme variables in styles/tokens.css (the single
 * source of truth) — keep the two in sync. Inline styles and Recharts props
 * read these; new components should prefer Tailwind utility classes. Iron
 * rules for any new UI: frontend/DESIGN_SYSTEM.md. The legacy dark palette
 * lives at src/demo/legacyTheme.js and is for archived demo tabs only.
 *
 * Color semantics (see .impeccable.md): accent orange = interactive ONLY,
 * green = approve/ok ONLY, red = veto/danger ONLY.
 */

// ── Core palette ──
export const COLORS = {
  bg:       "#faf6ec",
  panel:    "#ffffff",
  border:   "#000000",

  accent:   "#e24500",
  accentDim:"#ffe4d3",
  accentBr: "#b83700",
  accentFill:"#ff5b24",

  warn:     "#a86a00",
  warnDim:  "#fff0cc",

  danger:   "#cc1b00",
  dangerDim:"#ffded8",

  blue:     "#1f5fe0",
  blueDim:  "#dce8ff",

  violet:   "#7b4ba0",
  violetDim:"#f1eaf7",

  gold:     "#8a6d1a",
  goldDim:  "#f7f1dd",

  cyan:     "#0e7490",

  ok:       "#128a4b",
  okDim:    "#d9f5e4",

  text:     "#14110b",
  textDim:  "#4a463c",
  textBr:   "#000000",
  overlay:  "rgba(0, 0, 0, 0.45)",  // modal/dialog scrim; inline-only token

  grid:     "#e6e2d6",

  // Division identities (mid-tones, readable on light surfaces)
  morpheus: "#0e8a5f",
  adam:     "#0e7490",
  exec:     "#b45309",
  finance:  "#2c5d9e",
  oiaa:     "#7b4ba0",
  tiberius: "#8b5cf6",
};

// ── Font stacks ──
export const DISPLAY_FONT = "'Bricolage Grotesque Variable','Bricolage Grotesque',ui-sans-serif,system-ui,sans-serif"; // headings
export const SANS_FONT = "'DM Sans',ui-sans-serif,system-ui,sans-serif";                // body
export const MONO_FONT = "'Space Mono',ui-monospace,'SF Mono',monospace";               // data/labels

// ── Decision color map (semantic: green=approve, red=veto, amber=counter) ──
export const DECISION_COLORS = {
  approve:          COLORS.ok,
  veto:             COLORS.danger,
  counter_proposal: COLORS.warn,
};

// ── Division color map ──
export const DIVISION_COLORS = {
  Morpheus:  COLORS.morpheus,
  Adam:      COLORS.adam,
  Execution: COLORS.exec,
  Finance:   COLORS.finance,
  OIAA:      COLORS.oiaa,
};
